module.exports = __webpack_public_path__ + "img/sample_storyboard_2.4365cdd4.png";